import styled from 'styled-components';
import { tradingMessagesStyles } from 'components/molecules/trading_messages/styles';

export const Container = styled.div`
  @import 'bootstrap/base';
  @import 'bootstrap/react-select';

  .cursor-default {
    cursor: default !important;
  }
  .monitoring-notification {
    overflow: hidden;
    text-indent: 50px;
    width: 8px;
    height: 8px;
    border-radius: 100%;
    padding: 0;
  }
  .monitoring .list-group {
    height: 100%;
    overflow-y: scroll;
  }

  @-moz-document url-prefix() {
    .monitoring .list-group {
      scrollbar-width: thin;
      scrollbar-color: ${(props) => props.theme.$gray500} #fff;
      padding-right: 0.5rem;
      box-sizing: content-box;
    }
  }
  .monitoring .list-group::-webkit-scrollbar {
    width: 1rem;
  }
  .monitoring .list-group::-webkit-scrollbar-track {
    border: 0;
  }
  .monitoring .list-group::-webkit-scrollbar-thumb {
    border-radius: 100px;
    background-color: ${(props) => props.theme.$gray500};
    -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
    border-right: 0.3rem solid ${(props) => props.theme.$white};
    border-left: 0.3rem solid ${(props) => props.theme.$white};
    border-top: 0.2rem solid ${(props) => props.theme.$white};
    border-bottom: 0.2rem solid ${(props) => props.theme.$white};
  }
  .monitoring .list-group-item {
    cursor: pointer;

    &:hover {
      background: ${(props) => props.theme.$gray200};
    }
  }
  .monitoring .list-group-item.current {
    background-color: ${(props) => props.theme.$info};
    color: white;
    border-color: ${(props) => props.theme.$info} !important;

    @media only screen and (max-width: 768px) {
      background-color: ${(props) => props.theme.$white};
      color: ${(props) => props.theme.$gray700};
      border-color: ${(props) => props.theme.$gray300} !important;
    }
  }
  .monitoring .list-group-item.current:hover {
    background-color: #1096ab;
    color: white;
  }
  .monitoring-header {
    background: ${(props) => props.theme.$deep_police_blue};
    border-color: ${(props) => props.theme.$gray400} !important;

    i {
      font-size: 24px;
    }

    .dropdown-toggle::after {
      display: none !important;
    }

    .dropdown-item {
      font-size: 0.95rem;
    }
  }
  .monitoring-header-orgao,
  .monitoring-header-data {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    min-width: 0;
    font-size: 0.9em;
  }
  @media only screen and (max-width: 768px) {
    .monitoring-header-orgao {
      white-space: normal;
    }
  }
  .monitoring-header p:last-child {
    font-size: 100%;
  }
  .monitoring-public-body {
    font-size: 0.9em;
    max-width: 100%;
  }
  .monitoring-bar,
  .monitoring-sidebar {
    border-color: ${(props) => props.theme.$gray400} !important;
  }
  .monitoring-sidebar {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 56px);
  }
  .monitoring-bidding {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 56px);

    @media only screen and (max-width: 768px) {
      position: absolute;
      right: -100%;
      z-index: 999;

      &.open-mobile {
        right: 0;
        padding: 0;
        width: 100vw;
      }
    }
  }
  .monitoring-back {
    background: ${(props) => props.theme.$gray300};
    border-color: ${(props) => props.theme.$gray400} !important;
  }
  ${tradingMessagesStyles}
  .monitoring-btn:hover {
    background: #dfdfdf;
  }
  .badge {
    font-size: 80%;
  }
  .badge-comprasnet {
    background: #66a33c;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #66a33c !important;
      color: #fff !important;
    }
  }
  .badge-licitacoese {
    background: #b86ad5;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #b86ad5 !important;
      color: #fff !important;
    }
  }
  .badge-portalcompraspublicas {
    background: #f90;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #f90 !important;
      color: #fff !important;
    }
  }
  .badge-peintegrado {
    background: #009;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #009 !important;
      color: #fff !important;
    }
  }
  .badge-banrisul {
    background: #006eb8;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #006eb8 !important;
      color: #fff;
    }
  }
  .badge-comprasrs {
    background: #36854a;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #36854a !important;
      color: #fff !important;
    }
  }
  .badge-famesp {
    background: #487a7a;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #487a7a !important;
      color: #fff !important;
    }
  }
  .badge-sestdf {
    background: #46c26d;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #46c26d !important;
      color: #fff !important;
    }
  }
  .badge-sigarj {
    background: #264599;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #264599 !important;
      color: #fff !important;
    }
  }
  .badge-licitapp {
    background: #f85a5a;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #f85a5a !important;
      color: #fff !important;
    }
  }
  .badge-comprasam {
    background: #d2deab;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #d2deab !important;
      color: #fff !important;
    }
  }
  .badge-seplagmt {
    background: #9a963e;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #9a963e !important;
      color: #fff !important;
    }
  }
  .badge-bllcompras {
    background: #5ce91e;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #5ce91e !important;
      color: #fff !important;
    }
  }
  .badge-bnccompras {
    background: #11c68c;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #11c68c !important;
      color: #fff !important;
    }
  }
  .badge-licitanet {
    background: #a73c82;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #a73c82 !important;
      color: #fff !important;
    }
  }
  .badge-prcpcuritiba {
    background: #6a5e38;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #6a5e38 !important;
      color: #fff !important;
    }
  }
  .badge-comprasitaipu {
    background: #006;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #006 !important;
      color: #fff !important;
    }
  }
  .badge-comprasap {
    background: #060;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #060 !important;
      color: #fff !important;
    }
  }
  .badge-licitacoese2 {
    background: #606;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #606 !important;
      color: #fff !important;
    }
  }
  .badge-publinexo {
    background: #3cf;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #3cf !important;
      color: #fff !important;
    }
  }
  .badge-comprasmanaus {
    background: #595959;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #595959 !important;
      color: #fff !important;
    }
  }
  .badge-comprasnetdispensa {
    background: #862d86;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #862d86 !important;
      color: #fff !important;
    }
  }
  .badge-licitardigital {
    background: #d279d2;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #d279d2 !important;
      color: #fff !important;
    }
  }
  .badge-ammlicita {
    background: #f00;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #f00 !important;
      color: #fff !important;
    }
  }
  .badge-cemig {
    background: #c90;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #c90 !important;
      color: #fff !important;
    }
  }
  .badge-comprascampogrande {
    background: #a84848;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #a84848 !important;
      color: #fff !important;
    }
  }
  .badge-centralcomprasms {
    background: #d69200;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #d69200 !important;
      color: #fff !important;
    }
  }
  .badge-comprasma {
    background: #b89854;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #b89854 !important;
      color: #fff !important;
    }
  }
  .badge-procergs {
    background: #718742;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #718742 !important;
      color: #fff !important;
    }
  }
  .badge-copasa {
    background: #5200cc;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #5200cc !important;
      color: #fff !important;
    }
  }
  .badge-brconectado {
    background: #ffcc00;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #ffcc00 !important;
      color: #fff !important;
    }
  }
  .badge-selcorp {
    background: #4d88ff;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #4d88ff !important;
      color: #fff !important;
    }
  }
  .badge-olimpia {
    background: #8585ad;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #8585ad !important;
      color: #fff !important;
    }
  }
  .badge-itapolis {
    background: #5353c6;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #5353c6 !important;
      color: #fff !important;
    }
  }
  .badge-demervallobao {
    background: #6d735f;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #6d735f !important;
      color: #fff !important;
    }
  }
  .badge-maranhaozinho {
    background: #630;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #630 !important;
      color: #fff !important;
    }
  }
  .badge-humbertocampos {
    background: #b30000;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #b30000 !important;
      color: #fff !important;
    }
  }
  .badge-itingamaranhao {
    background: #ff4d4d;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #ff4d4d !important;
      color: #fff !important;
    }
  }
  .badge-cajari {
    background: #b36b00;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #b36b00 !important;
      color: #fff !important;
    }
  }
  .badge-anajatuba {
    background: #ffa31a;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #ffa31a !important;
      color: #fff !important;
    }
  }
  .badge-saojosebelmonte {
    background: #39e600;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #39e600 !important;
      color: #fff !important;
    }
  }
  .badge-igarapegrande {
    background: #134d00;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #134d00 !important;
      color: #fff !important;
    }
  }
  .badge-burititocantins {
    background: #3366cc;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #3366cc !important;
      color: #fff !important;
    }
  }
  .badge-tufilandia {
    background: #193366;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #193366 !important;
      color: #fff !important;
    }
  }
  .badge-sucupiranorte {
    background: #ff9966;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #ff9966 !important;
      color: #fff !important;
    }
  }
  .badge-sampaio {
    background: #e64d00;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #e64d00 !important;
      color: #fff !important;
    }
  }
  .badge-grajau {
    background: #9999ff;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #9999ff !important;
      color: #fff !important;
    }
  }
  .badge-igarapemeio {
    background: #0000e6;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #0000e6 !important;
      color: #fff !important;
    }
  }
  .badge-saodomingos {
    background: #009999;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #009999 !important;
      color: #fff !important;
    }
  }
  .badge-alcantara {
    background: #006666;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #006666 !important;
      color: #fff !important;
    }
  }
  .badge-vilanovamartirios {
    background: #003399;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #003399 !important;
      color: #fff !important;
    }
  }
  .badge-colinas {
    background: #3333ff;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #3333ff !important;
      color: #fff !important;
    }
  }
  .badge-pindaremirim {
    background: #0000b3;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #0000b3 !important;
      color: #fff !important;
    }
  }
  .badge-chaval {
    background: #6699ff;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #6699ff !important;
      color: #fff !important;
    }
  }
  .badge-conceicaolagoacu {
    background: #0055ff;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #0055ff !important;
      color: #fff !important;
    }
  }
  .badge-camarasantafilomenamaranhao {
    background: #ff6699;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #ff6699 !important;
      color: #fff !important;
    }
  }
  .badge-paraibano {
    background: #e6004c;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #e6004c !important;
      color: #fff !important;
    }
  }
  .badge-centroguilherme {
    background: #c6538c;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #c6538c !important;
      color: #fff !important;
    }
  }
  .badge-turiacu {
    background: #d279a6;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #d279a6 !important;
      color: #fff !important;
    }
  }
  .badge-mirador {
    background: #999966;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #999966 !important;
      color: #fff !important;
    }
  }
  .badge-assembleialegislativama {
    background: #996600;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #996600 !important;
      color: #fff !important;
    }
  }
  .badge-saojoseribamar {
    background: #ff3333;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #ff3333 !important;
      color: #fff !important;
    }
  }
  .badge-saoroberto {
    background: #009973;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #009973 !important;
      color: #fff !important;
    }
  }
  .badge-primeiracruz {
    background: #5c8a8a;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #5c8a8a !important;
      color: #fff !important;
    }
  }
  .badge-davinopolis {
    background: #009933;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #009933 !important;
      color: #fff !important;
    }
  }
  .badge-mirandiba {
    background: #8000ff;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #8000ff !important;
      color: #fff !important;
    }
  }
  .badge-saojosebasilios {
    background: #4d4dff;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #4d4dff !important;
      color: #fff;
    }
  }
  .badge-esperantinopolis {
    background: #b3b3ff;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #b3b3ff !important;
      color: #fff !important;
    }
  }
  .badge-lagoverde {
    background: #ff3385;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #ff3385 !important;
      color: #fff !important;
    }
  }
  .badge-presidentemedici {
    background: #b30059;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #b30059 !important;
      color: #fff !important;
    }
  }
  .badge-santoamaromaranhao {
    background: #ff0000;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #ff0000 !important;
      color: #fff !important;
    }
  }
  .badge-barreirinhas {
    background: #ff8080;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #ff8080 !important;
      color: #fff !important;
    }
  }
  .badge-perimirim {
    background: #ffa64d;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #ffa64d !important;
      color: #fff !important;
    }
  }
  .badge-santanamaranhao {
    background: #804000;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #804000 !important;
      color: #fff !important;
    }
  }
  .badge-novaolinda {
    background: #33ccff;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #33ccff !important;
      color: #fff !important;
    }
  }
  .badge-belagua {
    background: #007399;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #007399 !important;
      color: #fff !important;
    }
  }
  .badge-urbanosantos {
    background: #ccf2ff;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #ccf2ff !important;
      color: #fff !important;
    }
  }
  .badge-pioxii {
    background: #00cca3;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #00cca3 !important;
      color: #fff !important;
    }
  }
  .badge-domingosmourao {
    background: #008066;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #008066 !important;
      color: #fff !important;
    }
  }
  .badge-gilbues {
    background: #00e600;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #00e600 !important;
      color: #fff !important;
    }
  }
  .badge-carolina {
    background: #b3ffb3;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #b3ffb3 !important;
      color: #fff !important;
    }
  }
  .badge-morros {
    background: #99cc00;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #99cc00 !important;
      color: #fff !important;
    }
  }
  .badge-montesaltos {
    background: #b3b300;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #b3b300 !important;
      color: #fff !important;
    }
  }
  .badge-zedoca {
    background: #e63900;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #e63900 !important;
      color: #fff !important;
    }
  }
  .badge-marajasena {
    background: #ff9f80;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #ff9f80 !important;
      color: #fff !important;
    }
  }
  .badge-novaiorque {
    background: #b31aff;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #b31aff !important;
      color: #fff !important;
    }
  }
  .badge-coreau {
    background: #ff9999;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #ff9999 !important;
      color: #fff !important;
    }
  }
  .badge-brejo {
    background: #669999;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #669999 !important;
      color: #fff !important;
    }
  }
  .badge-barreiraspiaui {
    background: #b3cccc;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #b3cccc !important;
      color: #fff !important;
    }
  }
  .badge-carire {
    background: #339966;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #339966 !important;
      color: #fff !important;
    }
  }
  .badge-moraujo {
    background: #006600;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #006600 !important;
      color: #fff !important;
    }
  }
  .badge-palmeirais {
    background: #669900;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #669900 !important;
      color: #fff;
    }
  }
  .badge-miguelleao {
    background: #ffff1a;
    color: #000;
    @media only screen and (max-width: 768px) {
      background: #ffff1a !important;
      color: #000 !important;
    }
  }
  .badge-palmeirastocantins {
    background: #adad85;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #adad85 !important;
      color: #fff !important;
    }
  }
  .badge-amapamaranhao {
    background: #00ffff;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #00ffff !important;
      color: #fff !important;
    }
  }
  .badge-jati {
    background: #4dff88;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #4dff88 !important;
      color: #fff !important;
    }
  }
  .badge-oeiras {
    background: #00bfff;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #00bfff !important;
      color: #fff !important;
    }
  }
  .badge-camarabarracorda {
    background: #b30059;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #b30059 !important;
      color: #fff !important;
    }
  }
  .badge-camaralagopedra {
    background: #ff7733;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #ff7733 !important;
      color: #fff !important;
    }
  }
  .badge-camaraprimeiracruz {
    background: #4dffdb;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #4dffdb !important;
      color: #fff !important;
    }
  }
  .badge-camarasaojosebelmonte {
    background: #999900;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #999900 !important;
      color: #fff !important;
    }
  }
  .badge-camarabrejo {
    background: #004de6;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #004de6;
      color: #fff !important;
    }
  }
  .badge-camarabarreirinhas {
    background: #ff1a1a;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #ff1a1a !important;
      color: #fff !important;
    }
  }
  .badge-saaeoeiras {
    background: #ffcccc;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #ffcccc !important;
      color: #fff !important;
    }
  }
  .badge-bbmnet {
    background: #1e4b96;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #1e4b96 !important;
      color: #fff !important;
    }
  }
  .badge-licitama {
    background: #b02525;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #b02525 !important;
      color: #fff !important;
    }
  }
  .badge-portalsiades {
    background: #2a2170;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #2a2170 !important;
      color: #fff !important;
    }
  }
  .badge-senhorbonfim {
    background: #4080c0;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #4080c0 !important;
      color: #fff !important;
    }
  }
  .badge-campoformoso {
    background: #386641;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #386641 !important;
      color: #fff !important;
    }
  }
  .badge-jaguarari {
    background: #c00000;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #c00000 !important;
      color: #fff !important;
    }
  }
  .badge-pindobacu {
    background: #2040a0;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #2040a0 !important;
      color: #fff !important;
    }
  }
  .badge-filadelfia {
    background: #0080c0;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #0080c0 !important;
      color: #fff !important;
    }
  }
  .badge-caldeiraogrande {
    background: #5e548e;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #5e548e !important;
      color: #fff !important;
    }
  }
  .badge-saude {
    background: #e08020;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #e08020 !important;
      color: #fff !important;
    }
  }
  .badge-baixagrande {
    background: #e0a000;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #e0a000 !important;
      color: #fff !important;
    }
  }
  .badge-pontonovo {
    background: #e00080;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #e00080 !important;
      color: #fff !important;
    }
  }
  .badge-antoniogoncalves {
    background: #2080c0;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #2080c0 !important;
      color: #fff !important;
    }
  }
  .badge-varzeanova {
    background: #408000;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #408000 !important;
      color: #fff !important;
    }
  }
  .badge-varzeapoco {
    background: #000060;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #000060 !important;
      color: #fff !important;
    }
  }
  .badge-itiuba {
    background: #00c000;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #00c000 !important;
      color: #fff !important;
    }
  }
  .badge-camaracampoformoso {
    background: #6d597a;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #6d597a !important;
      color: #fff !important;
    }
  }
  .badge-camarapontonovo {
    background: #b5651d;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #b5651d !important;
      color: #fff !important;
    }
  }
  .badge-camaraitiuba {
    background: #008020;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #008020 !important;
      color: #fff !important;
    }
  }
  .badge-camarasenhorbonfim {
    background: #1565c0;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #1565c0 !important;
      color: #fff !important;
    }
  }
  .badge-camarajaguarari {
    background: #8c1c1c;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #8c1c1c !important;
      color: #fff !important;
    }
  }
  .badge-camaracaldeiraogrande {
    background: #4a6572;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #4a6572 !important;
      color: #fff !important;
    }
  }
  .badge-cpissenhorbonfim {
    background: #0060a0;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #0060a0 !important;
      color: #fff !important;
    }
  }
  .badge-cdstpni {
    background: #3d5a80;
    color: #fff;
    @media only screen and (max-width: 768px) {
      background: #3d5a80 !important;
      color: #fff !important;
    }
  }
  .current .badge,
  .current .monitoredBy {
    background: #fff;
    color: ${(props) => props.theme.$info};
  }

  .current .trading-toggle {
    color: ${(props) => props.theme.$white};
  }

  .current .dot {
    background-color: ${(props) => props.theme.$white};
    color: ${(props) => props.theme.$info};
    border: 1px solid ${(props) => props.theme.$info};
  }

  [class*='bidding-situation-'] {
    background-color: ${(props) => props.theme.$gray600};
    color: #fff;
    padding: 3px 7px;
  }
  .bidding-situation-nova {
    background-color: ${(props) => props.theme.$primary_green};
  }
  .bidding-situation-suspensa {
    background-color: ${(props) => props.theme.$warning};
  }
  .bidding-situation-suspensa-sine-die {
    background-color: ${(props) => props.theme.$warning};
  }
  .bidding-situation-urgente {
    background-color: ${(props) => props.theme.$danger};
  }

  @media only screen and (max-width: 768px) {
    .open-list-on-mobile {
      display: block;
    }
    .close-list-on-mobile {
      display: none;
    }
  }
`;
